import {
  MAX_FREE_AI_SUGGESTIONS,
  MAX_FREE_GOALS,
  MAX_FREE_HEALTH_AREAS,
  MAX_FREE_ROUTINES,
} from "./constants";
import {
  HeartPulse,
  Target,
  Repeat,
  Sparkles,
  LineChart,
  Calendar,
  Wrench,
  Rocket,
} from "lucide-react";

export const IOS_PRICING = {
  monthly_subscription: "monthly_subscription",
  yearly_subscription: "yearly_subscription2",
} as const;

export const MONTHLY_PRICE = "9.99";
export const YEARLY_PRICE = "77.99";
export const YEARLY_PRICE_PER_MONTH = "6.49";

export const getTranslatedPricing = (
  t: (key: string, params?: Record<string, string | number>) => string,
) =>
  ({
    free: {
      name: t("pricing.free.name"),
      description: t("pricing.free.description"),
      price: 0,
      period: t("pricing.free.period"),
      features: [
        { text: t("pricing.free.manage_routines", { count: MAX_FREE_ROUTINES }), icon: Repeat },
        {
          text: t("pricing.free.track_health_areas", { count: MAX_FREE_HEALTH_AREAS }),
          icon: HeartPulse,
        },
        { text: t("pricing.free.track_goals", { count: MAX_FREE_GOALS }), icon: Target },
        {
          text: t("pricing.free.ai_suggestions", { count: MAX_FREE_AI_SUGGESTIONS }),
          icon: Sparkles,
        },
        { text: t("pricing.free.basic_insights"), icon: LineChart },
        { text: t("pricing.free.core_tools"), icon: Wrench },
      ],
    },
    pro: {
      name: t("pricing.pro.name"),
      description: t("pricing.pro.description"),
      monthlyPrice: MONTHLY_PRICE,
      yearlyPricePerMonth: YEARLY_PRICE_PER_MONTH,
      yearlyPrice: YEARLY_PRICE,
      yearlyDiscount: 35, // percentage
      features: [
        { text: t("pricing.pro.unlimited_routines"), icon: Repeat },
        { text: t("pricing.pro.everything_free"), icon: Rocket },
        { text: t("pricing.pro.unlimited_health_areas"), icon: HeartPulse },
        { text: t("pricing.pro.unlimited_goals"), icon: Target },
        { text: t("pricing.pro.unlimited_ai"), icon: Sparkles },
        { text: t("pricing.pro.advanced_analytics"), icon: LineChart },
        { text: t("pricing.pro.calendar_integration"), icon: Calendar },
      ],
    },
  }) as const;
